import { IHtmlMutatorAutoClosing, THtmlMutator, TMutator } from '../../models/mutate-html';

import { autoClosingTagRegexp, closingTagRegexp, openingTagRegexp } from './regexps';

function isAutoClosing(config: THtmlMutator): config is IHtmlMutatorAutoClosing {
    return 'autoClosing' in config;
}

function updater(textPart: string, mutator: TMutator, metaData?: string) {
    return typeof mutator === 'function' ? mutator(textPart, metaData) : mutator;
}

export function htmlMutator(config: THtmlMutator): (text: string) => string {
    let mutator = null;

    if (isAutoClosing(config)) {
        const { autoClosing, tag } = config;
        const autoClosingRegexp = autoClosingTagRegexp(tag);

        mutator = (text: string) =>
            text.replace(autoClosingRegexp, (textPart: string) => updater(textPart, autoClosing));
    } else {
        const { closing, opening, tag } = config;
        const openingRegexp = openingTagRegexp(tag);
        const closingRegexp = closingTagRegexp(tag);
        const openCloseConnector: string[] = [];
        let processingTagIndex = 0;

        mutator = (text: string) =>
            text
                .replace(openingRegexp, (textPart: string) => {
                    openCloseConnector.push(textPart);

                    return updater(textPart, opening);
                })
                .replace(closingRegexp, (textPart: string) => {
                    const openingTag = openCloseConnector[processingTagIndex];

                    processingTagIndex += 1;

                    return updater(textPart, closing, openingTag);
                });
    }

    return mutator;
}
